export default "images/剩余电量-中高电量.png";